import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center justify-center flex-wrap md:justify-between bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-col items-center md:flex-row justify-between" }
const _hoisted_3 = { class: "max-w-lg w-full md:w-56 lg:max-w-xs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_5 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_6 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8" }
const _hoisted_9 = { class: "max-w-full overflow-x-auto" }

import { inject, onMounted, ref, computed, watch } from "vue";
import { AxiosInstance } from "axios";
import Navbar from "@/components/tools/Navbar.vue";
import Pagination from "@/components/tools/Pagination.vue";
import { useRoute } from "vue-router";
import DataTable from "@/components/tools/DataTable.vue";
import stringify from "qs-stringify";
import "dayjs/locale/th";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { formatNumber, translate } from "@/utils/tools";
import { SearchIcon } from "@heroicons/vue/solid";
import BannerEdit from "../../components/dialogs/BannerEdit.vue";
import BannerCreateDialog from "../../components/dialogs/BannerCreateDialog.vue";
import BannerFilterDialog from "@/components/dialogs/BannerFilterDialog.vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'Banner',
  setup(__props) {

dayjs.extend(localizedFormat);

const axios = inject("$axios") as AxiosInstance;
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref<boolean>(false);
const detailDialogModal = ref<boolean>(false);
const createBannerModal = ref<boolean>(false);
const editBannerModal = ref<boolean>(false);
const selectedRow = ref({});
const store = useStore();
const columns = ref([
  {
    label: translate("messages.banner.id"),
    field: "id",
    isSorted: false,
    sort: true,
  },
  {
    label: translate("messages.banner.image"),
    field: "url",
    isImages: true,
  },
  {
    label: translate("messages.banner.slug"),
    field: "slug",
    class: () => "w-32 flex flex-wrap",
    isSorted: false,
    sort: true,
  },
  {
    label: translate("messages.banner.keyname"),
    field: "keyName",
    class: () => "w-32 flex flex-wrap",
    isSorted: false,
    sort: true,
  },
  {
    label: translate("messages.banner.description"),
    field: "description",
    format: (data: any) => {
      if (data.description.length > 30) {
        return `${data.description.substring(
          0,
          (window.innerWidth / 2) * 0.02
        )}...`;
      }
      return data.description;
    },
    sort: false,
  },
  {
    label: translate("messages.banner.publish"),
    field: "publish",
    class: (data: any) => {
      if (data.publish) {
        return "inline-block text-xs py-1 px-2 rounded-lg bg-green-500 text-white";
      }
      return "inline-block text-xs py-1 px-2 rounded-lg bg-red-500 text-white";
    },
  },
  {
    label: translate("messages.banner.dateCreated"),
    field: "createdAt",
    align: "left",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
  {
    label: "",
    field: "",
    isEdit: true,
    sort: false,
  },
  {
    label: "",
    field: "",
    isFunction: true,
    format: () => "Delete",
    class: () => "bg-red-500 text-white cursor-pointer hover:bg-red-600",
    function: (data: any) => {
      removeBanner(data.id);
      fetchPageData();
    },
  },
]);
const data = ref([]);
const pageConfig = ref({
  page: 1,
  dataLength: 0,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  search: "",
  sort: [["id", "DESC"]],
});

const filterForm = ref({
  id: undefined,
  keyName: undefined,
  slug: undefined,
});

const fetchPageData = async (_reset = false) => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort, search } = pageConfig.value;
  const { id, keyName, slug } = filterForm.value;

  const payload = {
    requestTs: Date.now(),
    page,
    operatorId: store.state.selectedOperator.operatorId,
    keyName: search || keyName,
    slug: slug || null,
    pageSize: rowsPerPage,
    orderBy: [sort[0]],
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/banner/list-pagination`;
  const { rows } = await axios
    .post(url, payload)
    .then(({ data }) => data.result);

  // if (!rows || rows.length == 0) {
  //    if(pageConfig.value.page == 1){
  //     dataRows.value = []
  //     isLoaded.value = true;
  //     return
  //   }
  //   pageConfig.value.page = page - 1
  //   return
  // }

  dataRows.value = rows;
  pageConfig.value.dataLength = rows.length;
  // pageConfig.value.pageCount = Math.ceil(count / rowsPerPage);
  // pageConfig.value.count = count;

  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};

const edit = (e: any) => {
  selectedRow.value = e;
  editBannerModal.value = true;
};

const removeBanner = async (id: number) => {
  if (confirm(`Are you sure you want to delete this banner? (ID: ${id})`)) {
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/banner/delete`,
      { id }
    );
    fetchPageData();
  }
};

const filterModal = (flag?: number) => {
  if (flag === 1) {
    fetchPageData(true);
  } else {
    fetchPageData(false);
  }
  advanceFilterModal.value = false;
  detailDialogModal.value = false;
};

const doSort = (attName: string) => {
  // not working
  const index = columns.value.findIndex((column) => column.label === attName);
  if (!columns.value[index].sort) {
    return;
  }

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  let formattedAttName;
  if (attName.toLocaleLowerCase() === "key name") formattedAttName = "keyName";
  if (attName === "Date Created") formattedAttName = "id";
  sort[0] = [
    formattedAttName || attName.toLowerCase(),
    mode === "DESC" ? "ASC" : "DESC",
  ];
  fetchPageData(true);
};

watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = Number(route.query.page) || 1;
    fetchPageData();
  }
);
onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.banner.banners')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(SearchIcon), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
              class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
              type: "search",
              name: "search",
              placeholder: _ctx.$t('messages.banner.search'),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (fetchPageData(true)), ["enter"]))
            }, null, 40, _hoisted_7), [
              [_vModelText, pageConfig.value.search]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (advanceFilterModal.value = true)),
          class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
        }, [
          _createVNode(_component_font_awesome_icon, {
            class: "text-white mr-2",
            icon: ['far', 'filter'],
            transform: ""
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.banner.advanceFilter")), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (createBannerModal.value = true)),
          class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
        }, _toDisplayString(_ctx.$t("messages.banner.createBanner")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(DataTable, {
        columns: columns.value,
        data: dataRows.value,
        onSort: doSort,
        onEdit: edit,
        isLoaded: isLoaded.value
      }, null, 8, ["columns", "data", "isLoaded"]),
      _createVNode(Pagination, {
        config: pageConfig.value,
        "onUpdate:config": _cache[4] || (_cache[4] = ($event: any) => ((pageConfig).value = $event))
      }, null, 8, ["config"]),
      _createVNode(BannerEdit, {
        show: editBannerModal.value,
        "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((editBannerModal).value = $event)),
        form: selectedRow.value,
        onEdited: _cache[6] || (_cache[6] = ($event: any) => (fetchPageData())),
        onClosed: _cache[7] || (_cache[7] = ($event: any) => (fetchPageData()))
      }, null, 8, ["show", "form"]),
      _createVNode(BannerFilterDialog, {
        show: advanceFilterModal.value,
        "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((advanceFilterModal).value = $event)),
        form: filterForm.value,
        "onUpdate:form": _cache[9] || (_cache[9] = ($event: any) => ((filterForm).value = $event)),
        onFilter: _cache[10] || (_cache[10] = ($event: any) => (fetchPageData()))
      }, null, 8, ["show", "form"]),
      _createVNode(BannerCreateDialog, {
        show: createBannerModal.value,
        "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((createBannerModal).value = $event)),
        onCreated: _cache[12] || (_cache[12] = ($event: any) => (fetchPageData()))
      }, null, 8, ["show"])
    ])
  ], 64))
}
}

})